import { useCallback, useContext } from "react";
import { GlobalModalContext } from "src/utils/GlobalModal/GlobalModalContext";
import __ from "src/utils/Translations";
import AbsenceTypesSettings from "src/Pages/Company/Absences/AbsenceType/AbsenceTypesSettings/AbsenceTypesSettings";
import { IAbsenceType } from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

export const useAbsenceTypesSettings = () => {
  const { setModal, resetModal } = useContext(GlobalModalContext);

  const setAbsenceTypesSettings = useCallback(
    (absenceTypes: IAbsenceType[]) => {
      if (typeof setModal === "function") {
        setModal({
          open: true,
          title: <>{__("Ustawienie urlopu głównego")}</>,
          description: __(
            "Ustawienia widoku licznika w Panelu nieobecności. Wymiar wybranego szablonu będzie widoczny na stronie głównej pracownika."
          ),
          customElements: (
            <AbsenceTypesSettings
              absenceTypes={absenceTypes}
              resetModal={resetModal}
            />
          ),
          actions: null,
        });
      }
    },
    [resetModal, setModal]
  );

  return { setAbsenceTypesSettings };
};
